import { createSlice } from "@reduxjs/toolkit";

export interface CalendarState {
    viewMode: "Mes" | "Semana" | "Día";
}

export const initialState: CalendarState = {
    viewMode: 'Mes',
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        changeStorageViewMode: (state, action) => {
            state.viewMode = action.payload;
        },
    },
});

export const { changeStorageViewMode } = dashboardSlice.actions;

export default dashboardSlice.reducer;